import type { ComponentPropsWithoutRef } from 'react'

import { useStore } from '@nanostores/react'
import clsx from 'clsx'
import { useChatScheduled } from 'features/scheduled-messages/hooks'
import { $isScheduledShown } from 'features/scheduled-messages/store'
import { StackIcon } from 'shared/ui'

import css from './Indicator.module.css'

export function Indicator({
	className,
	...props
}: ComponentPropsWithoutRef<'button'>) {
	const { currentData } = useChatScheduled()

	const isActive = useStore($isScheduledShown)

	if (isActive || !currentData?.total) {
		return null
	}

	return (
		<button
			className={clsx(css.button, isActive && css.active)}
			type='button'
			{...props}
			onClick={() => $isScheduledShown.set(!isActive)}
		>
			<StackIcon icon='scheduled' />
		</button>
	)
}
